import axios from 'axios';
import React, { Component } from 'react';
import { Modal, FormControl, Button } from 'react-bootstrap';
import AxiosConfig from '../../../../../utilities/AxiosConfig';
import snackBar from '../../../../../utilities/snackBar/SnackBar';
// import { Modal, Button, FormControl } from 'react-bootstrap';
import uploadService from '../../../../../utilities/uploadService/uploadService';
import './NewInspection.css'

interface NewInspectionProps {
    details: any
    userId: any
    toggleNewInspection: Function
    refreshAll: Function

}

type NewInspectionTypes = {
    comments: string
    imagePreviews: Array<any>
    panDex: number
    image: any
    hasAllImages: boolean
    showNewInspectionConfirm: boolean
    setNewInspectionMileage: boolean
    mileage: string
    validMilaege: boolean
}

class NewInspection extends Component<NewInspectionProps, NewInspectionTypes>{

    images = [{ type: "Odometer", image: "", blob: "" }, { type: "Interior Driver", image: "", blob: "" }, { type: "Exterior Driver Front", image: "", blob: "" }, { type: "Exterior Passenger Front", image: "", blob: "" }, { type: "Exterior Passenger Rear", image: "", blob: "" }, { type: "Exterior Driver Rear", image: "", blob: "" }, { type: "License Plate", image: "", blob: "" }]
    others = [{ type: "Other", image: "", blob: "" }]

    constructor(props: any) {
        super(props)
        this.state = {
            comments: "",
            imagePreviews: this.images,
            panDex: 0,
            image: "",
            hasAllImages: false,
            showNewInspectionConfirm: false,
            setNewInspectionMileage: false,
            mileage: "",
            validMilaege: false
        }
    }

    componentDidMount() {
        uploadService.base64images = []
    }

    handleChange = (event: any) => {
        if (this.state.setNewInspectionMileage) {
            this.setState({ mileage: event.target.value })
        }
        if (this.state.showNewInspectionConfirm) {
            this.setState({ comments: event.target.value })
        }
    }

    uploadPictures = (VehicleInspectionId: number) => {
        const date = new Date()
        for (let i = 0; i < this.state.imagePreviews.length; i++) {
            if (this.state.imagePreviews[i].image !== "") {
                uploadService.setRequestbody({
                    VehicleNumber: this.props.details.VehicleNumber,
                    VehicleInformationId: this.props.details.VehicleInformationId,
                    VehicleMileage: this.state.mileage,
                    Latitude: 0,
                    Longitude: 0,
                    Heading: 0,
                    //@ts-ignore
                    TimeStamp: uploadService.base64images[i].date,
                    UTCOffset: date.getTimezoneOffset(),
                    //@ts-ignore
                    ClientImageKey: uploadService.base64images[i].date + "",
                    ClientUri: "file:///data/user/0/com.elm.elmlaunchpointmobile/cache/ExperienceData/%2540elmdev1%252FElmLaunchPointMobileApp/ImageManipulator/96740b2f-66d5-4a24-aad1-93d321657ba8.jpg",
                    ImageType: "VehicleInspection",
                    QueueStatus: "failed",
                    EmployeeId: parseInt(this.props.userId),
                    Orientation: 4,
                    EmployeeName: "",
                    EmployeeNumber: parseInt(this.props.userId),
                    VehicleInspectionId: VehicleInspectionId,
                    Index: i,
                    Position: this.state.imagePreviews[i].type.split(" ").join(""),
                    Descriptor: this.state.imagePreviews[i].type.split(" ").join(""),
                    //@ts-ignore
                    Base64Img: uploadService.base64images[i].Base64Img
                    //@ts-ignore
                    // ClientImageKey: uploadService.generateHash(uploadService.base64images[i].Base64Img)
                })
                uploadService.upload()
            }
        }
    }

    createInspection = () => {
        axios.get(process.env.REACT_APP_API_URL + "/api/Fleet/createInspection?vehicleinformationId=" + this.props.details.VehicleInformationId + "&createdby=" + this.props.userId + "&comments=" + this.state.comments, AxiosConfig.configValue())
            .then(res => {
                this.uploadPictures(res.data.VehicleInspectionId)
            }).then(
                this.props.refreshAll(),
                this.props.toggleNewInspection()
            ).catch(err => {
                //console.log(err, err.response);
                AxiosConfig.handleError(err);
                //handle error
            })
    }

    prepImage = (event: any) => {
        if (event.target.files[0]) {
            let img = event.target.files[0];
            uploadService.addImage(event.target.files[0])
            this.addImage(URL.createObjectURL(img))
        }
    }

    addImage = (img: any) => {
        this.images[this.state.panDex].image = img
        this.setState({ imagePreviews: this.images })
        this.lengthCheck()
        this.panPreview("+")
    }

    panPreview = (direction: string) => {
        if (direction === "+") {
            if (this.state.panDex < this.state.imagePreviews.length - 1) {
                this.setState({ panDex: this.state.panDex + 1 })
            }
        } else {
            if (this.state.panDex > 0) {
                this.setState({ panDex: this.state.panDex - 1 })
            }
        }
    }

    lengthCheck = () => {
        //fix this
        if (!this.state.hasAllImages) {
            let validcount = 0
            for (let i = 0; i < this.state.imagePreviews.length; i++) {
                if (this.state.imagePreviews[i].image.length > 0) {
                    validcount = validcount + 1
                }
            }
            if (validcount > this.state.imagePreviews.length - 1) {
                let temp = this.state.imagePreviews
                temp.push({ type: "Other", image: "", blob: "" })
                this.setState({ hasAllImages: true, imagePreviews: temp })
            } else {
                this.setState({ hasAllImages: false })
            }
        }
    }

    toggleConfirm = () => {
        if (this.state.showNewInspectionConfirm) {
            this.setState({ showNewInspectionConfirm: false, setNewInspectionMileage: false })
        } else {
            this.setState({ showNewInspectionConfirm: true, setNewInspectionMileage: false })
        }
    }

    toggleMileage = () => {
        if (this.state.setNewInspectionMileage) {
            this.setState({ setNewInspectionMileage: false })
        } else {
            this.setState({ setNewInspectionMileage: true })
        }
    }

    setMiles = () => {
        let l = parseInt(this.state.mileage)
        let r = parseInt(this.props.details.Mileage)
        if ((l > r) || this.props.details.Mileage === "") {
            this.setState({ setNewInspectionMileage: false, validMilaege: true })
        } else {
            this.setState({ validMilaege: false })
            snackBar({ text: "Miles must be greater than last inspection", type: "error", timeout: 5000 })
        }
    }

    render() {

        return (
            <div className="NewInspection">
                {this.state.setNewInspectionMileage && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                >
                    <Modal.Header>
                        <Modal.Title> <span className="material-icons">info</span>Enter Vehicle Mileage</Modal.Title>
                    </Modal.Header>
                    <div className="VI-Modal-Input">
                        <FormControl as="textarea" rows={4}
                            placeholder={"Mileage..."}
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.mileage}
                        />
                    </div>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.toggleMileage()}>Back <span id="new-inspection-edit-icon" className="material-icons">arrow_back</span></Button>
                        <Button variant="primary" onClick={() => this.setMiles()}>Submit</Button>
                    </Modal.Footer>
                </Modal>}
                {this.state.showNewInspectionConfirm && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                >
                    <Modal.Header>
                        <Modal.Title> <span className="material-icons">help_outline</span>Submit this Inspection?</Modal.Title>
                    </Modal.Header>
                    <div className="VI-Modal-Input">
                        <FormControl as="textarea" rows={4}
                            placeholder={"Comments..."}
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            onChange={this.handleChange}
                            value={this.state.comments}
                        />
                    </div>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => this.createInspection()}>Submit</Button>
                        <Button variant="secondary" onClick={() => this.toggleConfirm()}>Edit <span id="new-inspection-edit-icon" className="material-icons">create</span></Button>
                    </Modal.Footer>
                </Modal>}
                <div className="Exit-New-Inspection-View" onClick={() => this.props.toggleNewInspection()}>
                    <span className="material-icons">close</span>
                </div>
                <div className="New-Inspection-Pan-Btns">
                    <div id="add-inspection-pan-left">
                        <span className="material-icons" onClick={() => this.panPreview("-")}>keyboard_arrow_left</span>
                    </div>
                    <div id="add-inspection-pan-right">
                        <span className="material-icons" onClick={() => this.panPreview("+")}>keyboard_arrow_right</span>
                    </div>
                </div>
                <p>{this.state.imagePreviews[this.state.panDex].type}</p>
                <div className="Add-Inspection-Image-Preview">
                    {this.state.imagePreviews[this.state.panDex].image !== "" && <img src={this.state.imagePreviews[this.state.panDex].image} alt=""></img>}
                    {this.state.imagePreviews[this.state.panDex].image === "" && <span className="material-icons-outlined">photo_size_select_large</span>}
                </div>
                <div className="Add-Inspection-Image-Carousel">
                    {this.state.imagePreviews.map((img, i) =>
                        <div className="Add-Inspection-Image-Carousel-Wrapper" key={i}>
                            {this.state.panDex !== i && <div className="add-inspection-image-carousel-image-wrapper-not-focused" key={"add-inspection-image-carousel-image-not-focused" + i}>
                                {img.image !== "" && <img src={img.image} alt=""></img>}
                                {img.image === "" && <span className="material-icons-outlined">insert_photo</span>}
                                {/* <p>{img.type}</p> */}
                            </div>}
                            {this.state.panDex === i && <div className="add-inspection-image-carousel-image-wrapper-focused" key={"add-inspection-image-carousel-image-focused" + i}>
                                {img.image !== "" && <img src={img.image} alt=""></img>}
                                {img.image === "" && <span className="material-icons-outlined">insert_photo</span>}
                                {/* <p>{img.type}</p> */}
                            </div>}
                        </div>
                    )}
                </div>
                <div className="new-inspection-custom-file-upload-wrapper">
                    <label className="new-inspection-custom-file-upload">
                        Choose File
                    <input id="ChooseFile" type="file" onChange={this.prepImage} />
                    </label>
                    {!this.state.validMilaege && <Button id="new-inspection-miles-btn-invalid" variant="danger" onClick={() => this.toggleMileage()}>Set Miles</Button>}
                    {this.state.validMilaege && <Button id="new-inspection-miles-btn-valid" variant="primary" onClick={() => this.toggleMileage()}>Set Miles ({this.state.mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")})</Button>}
                    {this.state.hasAllImages && this.state.validMilaege && <Button id="new-inspection-next-btn" variant="primary" onClick={() => this.toggleConfirm()}>Next</Button>}
                </div>
            </div>
        )
    }
}

export default NewInspection